module.exports = __webpack_public_path__ + "static/img/R141B.a3cefce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/oem/R141B.jpg
// module id = efTR
// module chunks = 1